import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';

export interface IChangeToManualForm {
  floorPrice: number | null;
  floorPriceUom: string;
  listPrice: number | null;
  listPriceUom: string;
}

export const changeToManualSchema = () =>
  yup.object({
    listPrice: numberSchemaWithTransform()
      .label(t('labelListPrice'))
      .required(getEmptyErrorMessage(t('labelListPrice'))),
    listPriceUom: yup
      .string()
      .label(t('labelUom'))
      .required(getEmptyErrorMessage(t('labelUom'))),
    floorPrice: numberSchemaWithTransform().label(t('labelFloorPrice')).nullable(),
    floorPriceUom: yup
      .string()
      .label(t('labelUom'))
      .when('floorPrice', {
        is: (value: number | null | undefined) => value != null,
        then: (schema) => schema.required(getEmptyErrorMessage(t('labelUom'))),
        otherwise: (schema) => schema,
      }),
  });
